import React from 'react'
import useFetchApi from '../../hooks/useFetchApi';

function PriceList() {
    const url = 'https://orisoftpl.com/backend/api/frontend/home';
    const { data: mandapData } = useFetchApi({
        url,
        dataKey: 'mandaps',
    });
    return (
        <div className="w-4/5 mx-auto mt-16">

            {/* HEADING */}
            <div className="text-center mb-10">

                <h2 className="text-3xl font-bold text-black drop-shadow-sm">
                    Booking Prices
                </h2>

                <p className="text-gray-600 mt-3 text-lg">
                    List of services and their pricing.
                </p>

            </div>

            {/* PRICE LIST */}
            <div className="space-y-6">

                {mandapData.map((item) => {

                    const total =
                        Number(item.booking_amount) +
                        Number(item.user_fee);

                    return (

                        <div
                            key={item.id}
                            className="
                        bg-white
                        border
                        border-gray-200
                        shadow-lg
                        mt-0
                    "
                        >

                            <div className="grid grid-cols-5 items-center">

                                {/* NAME */}
                                <div className="h-full  border-r flex items-center p-3">

                                    <h3 className="text-xl font-bold text-blue-600">
                                        {item.name}
                                    </h3>

                                </div>

                                {/* BOOKING AMOUNT */}
                                <div className="h-full text-center border-r p-3 ">

                                    <p className="text-blue-500 text-md">
                                        Booking Amount
                                    </p>

                                    <h4 className="text-xl font-bold mt-3 text-gray-900">
                                        ₹ {item.booking_amount}/-
                                    </h4>

                                </div>

                                {/* USER FEE */}
                                <div className="h-full text-center border-r p-3">

                                    <p className="text-blue-500 text-md">
                                        User Fee
                                    </p>

                                    <h4 className="text-xl font-bold mt-3 text-gray-900">
                                        ₹ {item.user_fee}/-
                                    </h4>

                                </div>

                                {/* TOTAL + BUTTON */}
                                <div className="h-full text-center border-r p-3">

                                    <p className="text-blue-500 text-md">
                                        Total Amount
                                    </p>

                                    <h4 className="text-xl font-bold mt-3 text-gray-900">
                                        ₹ {total}/-
                                    </h4>



                                </div>

                                <div className="flex items-center justify-center">
                                    <button
                                        type="button"

                                        className="
                                    
                                    bg-red-600
                                    hover:bg-red-700
                                    text-white
                                    px-8
                                    py-3
                                    
                                    font-medium
                                    shadow-md
                                    transition-all
                                    duration-300
                                    hover:scale-105
                                "
                                    >
                                        Book Now
                                    </button>
                                </div>

                            </div>

                        </div>
                    );
                })}

            </div>

        </div>
    )
}

export default PriceList